__turbopack_context__.v({
  "figHost": "figureCss-module__ITpy2a__figHost",
});
